import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { AccordionSectionPresentationProps, ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import AccordionSectionPanel from "@insite/mobius/AccordionSection/AccordionSectionPanel";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { SPACING, TYPOGRAPHY } from "@store/theme/common/design";
import breakpointValuesMediaQueries from "@store/Framework/Common/Utilities/breakpointValuesMediaQueries";
import React, { FC } from "react";
import { css } from "styled-components";
import getColor from "@insite/mobius/utilities/getColor";

export interface ProductListFilterListStyles {
    accordionSectionMobile?: AccordionSectionPresentationProps;
}

export const filterListStyles: ProductListFilterListStyles = {
    accordionSectionMobile: {
        titleTypographyProps: {
            css: css`
                font-size: ${TYPOGRAPHY.size.larger};
                text-transform: none;
                margin-bottom: 0;
            `,
        },
        panelProps: {
            css: css`
                overflow-y: auto;
                overflow-x: hidden;
                border: none;
                margin: ${SPACING.xsmall} 0;
                padding: 0 ${SPACING.xsmall};

                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [
                            { values: [null, null, "block", null, null], properties: ["display"] },
                            { values: [`0 ${SPACING.xsmall}`, null, "0 0", null, null], properties: ["padding"] },
                        ],
                        mediaOptions.min,
                    )}
            `,
        },
        headerProps: {
            css: css`
                background-color: ${getColor("common.accent")};
                border: none;
                margin: ${SPACING.small} auto;

                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [{ values: [null, null, "none", null, null], properties: ["display"] }],
                        mediaOptions.min,
                    )}

                button {
                    border: 2px solid ${getColor("common.accent")};
                    padding: 1em;
                    font-size: ${TYPOGRAPHY.size.base};

                    &:focus {
                        padding: 1em;
                    }
                }
                ${/* sc-selector */ AccordionSectionPanel} + & button {
                    &:focus {
                        padding: 1em;
                    }
                }
            `,
        },
    },
};

const styles = filterListStyles;

const ProductListFilterResponsive = ({ id }: WidgetProps) => {
    const renderFilterContentZone = () => {
        return <Zone contentId={id} zoneName="Content" />;
    };

    return (
        <StyledWrapper>
            <ManagedAccordionSection
                title={translate("Filters")}
                {...styles.accordionSectionMobile}
                initialExpanded={false}
            >
                {renderFilterContentZone()}
            </ManagedAccordionSection>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ProductListFilterResponsive,
    definition: {
        group: "Product List",
        displayName: "Filter List Responsive container",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
